import {
  useCompositeStoreProps
} from "./EZ23JQKA.js";
import {
  useStore,
  useStoreProps
} from "./4LP74VAP.js";
import {
  __spreadProps,
  __spreadValues
} from "./PNRLI7OV.js";

// src/tab/tab-store.ts
import { useMemo } from "react";
import * as Core from "@ariakit/core/tab/tab-store";
function useTabStoreProps(store, update, props) {
  store = useCompositeStoreProps(store, update, props);
  useStoreProps(store, props, "selectedId", "setSelectedId");
  useStoreProps(store, props, "selectOnMove");
  const [panels] = useStore(() => store.panels, {});
  return useMemo(() => __spreadProps(__spreadValues({}, store), { panels }), []);
}
function useTabStore(props = {}) {
  const [store, update] = useStore(Core.createTabStore, props);
  return useTabStoreProps(store, update, props);
}

export {
  useTabStoreProps,
  useTabStore
};
